import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingFlipImageConfig } from '@/data/landingConfig/landingFlipImageConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_FlipImage } from './schemaObject';

interface Props {}
const FlipImage: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_FlipImage} />
			<LandingTemplate
				data={landingFlipImageConfig}
				funnelLinkService={GenerateLandingLinkService.funnelFlipRotateImage()}
			/>
		</>
	);
};

export default FlipImage;
